<template>
  <div class="seaPort-management-buttons-in-aggrid">
    <el-button v-permission="['mdm:seaport:view']" size="mini" type="text" @click="invokePopSeaPortForm"> {{ $t('Information.Edit') }} </el-button>
    <el-button v-permission="['mdm:seaport:del']" size="mini" type="text" class="button-in-grid-danger" @click="invokeDelSeaPortRow"> {{ $t('Information.Delete') }} </el-button>
    <el-button v-permission="['mdm:seaport:enable']" :class="{'button-in-grid-success':!seaPortStatus,'button-in-grid-warning':seaPortStatus}" size="mini" type="text" @click="invokeSwitchSeaPortStatus">
      {{ seaPortStatusBtn() }}
    </el-button>
  </div>
</template>
<script>
export default {
  name: 'SeaportOperateButtonCellRendererFramework',
  data() {
    return {
      seaPortStatus: true // 启用状态
    }
  },
  created() {
  },
  methods: {
    seaPortStatusBtn() {
      let val = this.$t('Information.Disable')
      if (!this.params.value) {
        val = this.$t('Information.Enable')
        this.seaPortStatus = false
      }
      return val
    },
    invokePopSeaPortForm() {
      const data = this.params.data
      this.params.context.componentParent.popSeaPortFormDialog(data.id)
    },
    invokeDelSeaPortRow() {
      const data = this.params.data
      const self = this
      this.$confirm(this.$t('Information.AreWantToDeleteRecord'), this.$t('Information.Notice'), {
        confirmButtonText: this.$t('Information.Confirm'),
        cancelButtonText: this.$t('Information.Cancel'),
        type: 'warning'
      }).then(() => {
        self.params.context.componentParent.delSeaPort(data.id)
        this.$message({
          type: 'success',
          message: this.$t('Information.SuccessfullyDeleted')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('Information.DeletionCancelled')
        })
      })
    },
    invokeSwitchSeaPortStatus() {
      const data = this.params.data
      this.params.context.componentParent.switchSeaPortStatus(data.id, !data.bActive)
    }
  }
}
</script>
<style scoped>
  .seaPort-management-buttons-in-aggrid .el-button{
    padding: 0;
  }
</style>

